import { render } from "./SimulatorItem.vue?vue&type=template&id=71d93474"
import script from "./SimulatorItem.vue?vue&type=script&lang=js"
export * from "./SimulatorItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__